import { withDashForFalsy } from './ag-formatters'

export const defaultColDef = {
  filter: true,
  resizable: true,
  sortable: true,
  suppressSizeToFit: true,
  valueFormatter: withDashForFalsy(),
  cellDataType: false,
  menuTabs: ['filterMenuTab', 'generalMenuTab'], // ensures filter tab by default when opening the context menu
  filterParams: {
    buttons: ['reset'], // applies the reset button to all filters
    defaultToNothingSelected: true,
    inRangeInclusive: true,
    showTooltips: true
  },
  headerComponentParams: {
    template: `
    <div class="ag-cell-label-container" role="presentation">
      <div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
        <span data-ref="eText" class="ag-header-cell-text"></span>
        <span
          data-ref="eFilterButton"
          onclick="event.stopPropagation();"
          class="ag-header-icon ag-header-label-icon ag-header-cell-filter-button ag-filter-icon"
          aria-hidden="true"
        ></span>
        <span data-ref="eSortOrder" class="ag-header-icon ag-header-label-icon ag-sort-order ag-hidden" aria-hidden="true"></span>
        <span data-ref="eSortAsc" class="ag-header-icon ag-header-label-icon ag-sort-order ag-sort-ascending-icon ag-hidden" aria-hidden="true"></span>
        <span data-ref="eSortDesc" class="ag-header-icon ag-header-label-icon ag-sort-order ag-sort-descending-icon ag-hidden" aria-hidden="true"></span>
        <span data-ref="eSortNone" class="ag-header-icon ag-header-label-icon ag-sort-order ag-sort-none-icon ag-hidden" aria-hidden="true"></span>
        <span class="ag-header-menu-container">
          <span
            data-ref="eMenu"
            onclick="event.stopPropagation();"
            class="ag-header-icon ag-header-cell-menu-button"
            aria-hidden="true"
          ></span>
        </span>
      </div>
    </div>
    `
  }
}
